import React, {PropTypes} from 'react';
import {Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import EntryRosterFormVirtualEntriesToModifyContainer from './EntryRosterFormVirtualEntriesToModifyContainer.jsx';

const EntryRosterForm = ({
  disableState, 
  roster,
  rosterPositionsQty,
  countries,
  states, 
  handleSubmit,
  submitting,
  onCancelClick,
  onSubmit,
  onCountryChange,
  errors
}) => {
   
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate>
      <ErrorListContainer/>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        "overflowY": 'auto',
        "overflowX": 'hidden',
        "marginRight": errors.length > 0 ? '-15px' : '0'
      }}>

        <div className={errors.length > 0 ? "modalNonErrorBody" : ""}>
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <Field
                disabled={rosterPositionsQty === 2 || rosterPositionsQty === 1}
                autoFocus={rosterPositionsQty > 2}
                className="form-control"
                name="name"
                type="text"
                placeholder="Team Name"
                component={StandardField}/>
            </div>
            <div className="col-sm-6 col-xs-12">
              <Field
                name="countryId"
                placeholder="Country"
                component={StandardSelectField}
                options={countries}
                simpleValue
                searchable
                matchPos="start"
                onCustomChange={onCountryChange}/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 col-xs-12">
              <Field
                disabled={disableState}
                className="form-control"
                name="state"
                placeholder="State"
                component={StandardSelectField}
                options={states}
                simpleValue
                searchable
                matchPos="start"/>
            </div>
            <div className="col-sm-4 col-xs-12">
              <Field
                className="form-control"
                name="groupCode"
                type="text"
                placeholder="Group Code"
                component={StandardField}
                maxLength="10"
                tooltip="Teams that want to bowl on lanes near each other should all have the same Group Code."
                tooltipPosition="top"/>
            </div>
            <div className="col-sm-4 col-xs-12">
              <Field
                className="form-control"
                name="pairCode"
                type="text"
                placeholder="Companion Code"
                component={StandardField}
                tooltip="(Optional) Enter the Reservation Number of the other team you want to bowl/cross with on your pair."
                tooltipPosition="top"/>
            </div>
          </div>

          {roster}
          <EntryRosterFormVirtualEntriesToModifyContainer/>
          <br/>

          <div className="form-group text-right">
            <button
              type="button"
              className="btn btn-link"
              disabled={submitting}
              onClick={onCancelClick}>Cancel</button>
            {` `}
            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={submitting}>{submitting ? <Submitting/> : <i className="fa fa-floppy-o"/>} {`Save Changes`
              }</button>
          </div>
        </div>
      </div>
    </form>
  );
};

EntryRosterForm.propTypes = {
  disableState: PropTypes.bool,
  roster: PropTypes.node,
  rosterPositionsQty: PropTypes.number,
  countries: PropTypes.arrayOf(PropTypes.object),
  states: PropTypes.arrayOf(PropTypes.object), 
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onSubmit: PropTypes.func,
  onCountryChange: PropTypes.func,
  errors: PropTypes.arrayOf(PropTypes.string)
};

EntryRosterForm.defaultProps = {
  disableState: false,
  rosterPositionsQty: 0,
  countries: [],
  states: [], 
  submitting: false
};

export default EntryRosterForm;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterForm.jsx